import SEO from "../components/SEO";

export default function Terms() {
  return (
    <div className="parchment min-h-screen pt-24 pb-24 px-6" data-testid="terms-page">
      <SEO
        title="Terms of Use"
        description="Simple, farmhouse-plain terms for using The Salty Moo™ site."
        path="/terms"
      />
      <div className="max-w-2xl mx-auto parchment-deep page-shadow border border-[#E7DFD5] rounded-md px-10 py-12">
        <p className="text-xs uppercase tracking-[0.4em] text-[#D62839] mb-3">
          Handshake-simple
        </p>
        <h1 className="font-display text-5xl text-[#4B3A2F] mb-2">Terms</h1>
        <div className="gold-rule w-20 mb-8" />

        <div className="space-y-5 font-body text-[#2C2724]/90 text-lg leading-relaxed">
          <p>
            Welcome. By reading, subscribing, or otherwise wandering the
            pastures of thesaltymoo.com, you agree to these gentle terms.
          </p>
          <p>
            <span className="font-display italic text-[#4B3A2F]">The stories, art, characters,</span>{" "}
            names, and marks (including &ldquo;The Salty Moo™,&rdquo;
            &ldquo;Lil Salties™,&rdquo; &ldquo;Saltie Brays™,&rdquo;
            &ldquo;Saltie Moos™,&rdquo; &ldquo;Saltie Winks™,&rdquo; and
            &ldquo;Peek-a-Moo™&rdquo;) belong to The Salty Moo. Please
            don&rsquo;t reproduce or sell them without written permission —
            but sharing a link is always welcome.
          </p>
          <p>
            <span className="font-display italic text-[#4B3A2F]">
              This site is offered as-is
            </span>{" "}
            with a warm heart. We do our best to keep it accurate and
            up-to-date, but we make no guarantees beyond that.
          </p>
          <p>
            Any products in the Story Barn &amp; Mercantile that are marked
            &ldquo;Coming Soon&rdquo; are not yet for sale. When they open up,
            you&rsquo;ll be the first to know from the porch.
          </p>
          <p className="font-script text-2xl text-[#4B3A2F] pt-4">
            questions? just holler.
          </p>
          <p>
            Reach out any time — hello@thesaltymoo.com — and a real person on
            the pasture will write you back.
          </p>
        </div>
      </div>
    </div>
  );
}
